// Config global de zod (se importa antes que cualquier esquema). `jitless`: sin `new Function`, que la CSP
// de producción bloquea (`script-src 'self'`, API §1) y reportaría como violación en cada carga.
import { z } from 'zod';

z.config({ jitless: true });
